<template>
  <div class="shell-page">
    <HeaderMain />

    <section class="legal-shell">
      <div class="glass-surface legal-card">
        <div class="section-heading">
          <span class="section-heading__eyebrow">Legal y confianza</span>
          <h1 class="section-heading__title">Terminos y condiciones</h1>
          <p class="section-heading__text">
            Transparencia, seguridad y claridad para que la experiencia de compra se sienta confiable antes, durante y despues del evento.
          </p>
        </div>

        <div class="legal-card__content">
          <section class="legal-page__highlight">
            <span class="legal-page__pill">Operador legal</span>
            <h2 class="legal-page__highlight-title">FOMOPLANES es parte de GINGO ENTERPRISES LLC</h2>
            <p>
              Direccion comercial registrada: 1209 MOUNTAIN ROAD PL NE STE R, ALBUQUERQUE, NM 87110.
            </p>
            <p>
              El canal oficial de soporte publicado por la plataforma es <a class="legal-page__text-link" href="mailto:fomoplanes@sudenec.com">fomoplanes@sudenec.com</a>.
            </p>
          </section>

          <section class="legal-page__section">
            <h2>1. Alcance de estos terminos</h2>
            <p>
              Estos terminos aplican a todas las versiones del sitio y aplicaciones de FOMOPLANES que contengan un enlace a este documento. Al visitar el sitio, registrarte o comprar entradas, aceptas quedar obligado por estas condiciones y por sus futuras actualizaciones.
            </p>
          </section>

          <section class="legal-page__section">
            <h2>2. Rol de la plataforma y de los organizadores</h2>
            <p>
              Los eventos publicados en FOMOPLANES son responsabilidad de sus organizadores. La plataforma se encarga de la comercializacion, promocion y exposicion digital de los accesos. Solo cuando un evento sea identificado expresamente como una experiencia propia o coorganizada por FOMOPLANES existira participacion directa en la produccion.
            </p>
          </section>

          <section class="legal-page__section">
            <h2>3. Registro, informacion del usuario y uso del servicio</h2>
            <p>
              La informacion personal compartida por el usuario para registro, validacion y compra se utiliza exclusivamente para fines del servicio. El usuario declara que la informacion entregada es autentica, actual y correcta.
            </p>
            <p>
              FOMOPLANES puede usar esa informacion para emitir entradas, confirmar pagos, atender soporte, prevenir fraude, responder requerimientos legales y coordinar incidencias relacionadas con eventos, accesos o reembolsos.
            </p>
          </section>

          <section class="legal-page__section">
            <h2>4. Pagos y procesadores autorizados</h2>
            <p>
              Las compras realizadas en la plataforma pueden procesarse mediante Stripe y otras pasarelas o procesadores autorizados, segun disponibilidad del evento, pais, moneda o metodo de pago habilitado. FOMOPLANES no almacena datos completos de tarjetas de credito o debito en la plataforma.
            </p>
            <p>
              Al completar un pago, el usuario tambien acepta las validaciones antifraude, autenticaciones reforzadas, verificaciones bancarias y reglas operativas propias del procesador seleccionado.
            </p>
          </section>

          <section class="legal-page__section">
            <h2>5. Revision de la compra y responsabilidad del comprador</h2>
            <p>
              El usuario es responsable de elegir correctamente fecha, funcion, localidad y cantidad de entradas antes de pagar. No existen cambios, devoluciones ni reembolsos por errores del comprador ni por fees de servicio ya aceptados durante la compra.
            </p>
          </section>

          <section class="legal-page__section">
            <h2>6. Cancelaciones, reprogramaciones y devoluciones</h2>
            <p>
              En caso de cancelacion, reprogramacion o devoluciones, la responsabilidad principal recae en el organizador. FOMOPLANES no es responsable por esas decisiones ni por su ejecucion final, aunque podra colaborar con la gestion cuando exista autorizacion previa o un acuerdo formal con el promotor correspondiente.
            </p>
            <p>
              Toda gestion de reembolso, credito, cambio o compensacion se analiza segun la politica del evento, la documentacion entregada por el comprador y las condiciones operativas del procesador de pago utilizado.
            </p>
          </section>

          <section class="legal-page__section">
            <h2>7. Fomo Safe</h2>
            <p>
              Cuando el usuario agregue el extra opcional Fomo Safe durante el checkout, dicho valor se cobra como un addon independiente dentro del mismo pago. Fomo Safe protege compras elegibles frente a imprevistos personales validables que impidan asistir y tambien frente a cancelacion oficial del evento, sin modificar el fee de servicio del organizador.
            </p>
            <p>
              Fomo Safe contempla imprevistos personales validables y cancelacion oficial del evento. No cubre reprogramacion, cambios de horario, cambios de venue, errores de compra, fees ya aceptados, decisiones operativas distintas de una cancelacion formal ni el valor del propio addon. Toda solicitud queda sujeta a revision documental y validacion interna de FOMOPLANES.
            </p>
          </section>

          <section class="legal-page__section">
            <h2>8. Prevencion de fraude y validez de boletos</h2>
            <p>
              FOMOPLANES puede invalidar boletos digitales cuando existan disputas, sospechas de fraude, contracargos, incumplimientos de seguridad o consumos irregulares. En esos casos, la plataforma puede solicitar informacion adicional antes de entregar accesos, confirmar compras o resolver una incidencia.
            </p>
          </section>

          <section class="legal-page__section">
            <h2>9. Legislacion aplicable y jurisdiccion</h2>
            <p>
              Estas condiciones se interpretan conforme a la legislacion aplicable de Estados Unidos y, cuando corresponda, del Estado de Nuevo Mexico. Cualquier controversia relacionada con el uso de la plataforma, los pagos procesados o la ejecucion de estos terminos se atendera segun la jurisdiccion competente aplicable a GINGO ENTERPRISES LLC.
            </p>
            <p>
              Las protecciones adicionales ofrecidas por cada pasarela de pago, banco emisor o red de tarjetas aplican de manera complementaria y no sustituyen estas condiciones.
            </p>
          </section>

          <section class="legal-page__section">
            <h2>10. Politicas relacionadas</h2>
            <p>
              Al continuar navegando o comprando en FOMOPLANES, aceptas tambien las politicas publicas complementarias de privacidad, reembolsos, contacto y compania publicadas en este sitio cuando correspondan al servicio utilizado.
            </p>

            <div class="legal-page__actions">
              <router-link :to="{ name: 'privacy' }">Politica de privacidad</router-link>
              <router-link :to="{ name: 'refunds' }">Reembolsos y cancelaciones</router-link>
              <router-link :to="{ name: 'contact' }">Contacto</router-link>
              <router-link :to="{ name: 'company' }">Compania</router-link>
            </div>
          </section>
        </div>
      </div>
    </section>

    <FooterMain />
  </div>
</template>

<script>
import HeaderMain from '@/components/HeaderMain.vue'
import FooterMain from '@/components/FooterMain.vue'

export default {
  name: 'TermsView',

  components: {
    HeaderMain,
    FooterMain,
  },
}
</script>

<style>
</style>
